// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"708b5f86","392":"708b5f86","614":"708b5f86","872":"035d0089","879":"708b5f86"}[chunkId] + ".chunk.css";
};